/* ZINGWINWIN theme — cart drawer, goals, quick add, bundles, product page, menus. No dependencies. */
(() => {
  const Z = window.ZW;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const rate = () => (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const tpl = (str, vars) => String(str).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => vars[k] ?? '');

  // ---------- money: amounts from /cart.js are already in the visitor's currency ----------
  const cur = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(cents) {
    try { return new Intl.NumberFormat(Z.locale, { style: 'currency', currency: cur() }).format((cents || 0) / 100); }
    catch { return ((cents || 0) / 100).toFixed(2) + ' ' + cur(); }
  }
  // store-currency thresholds printed by Liquid (data-money) -> visitor's currency, rounded like Shopify Markets
  document.querySelectorAll('[data-money]').forEach(el => {
    const v = Number(el.dataset.money) * rate();
    el.textContent = money(rate() === 1 ? v : Math.ceil(v / 100) * 100).replace(/[.,]00(?=\D*$)/, '');
  });

  // ---------- toast ----------
  let toastT;
  function toast(html) {
    const t = $('.toast'); if (!t) return;
    t.innerHTML = html; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 3400);
  }

  // ---------- cart API ----------
  const api = async (url, body) => {
    const r = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || Z.t.error);
    return data;
  };
  const getCart = () => api(Z.routes.cart + '.js');
  let cart = null;
  let busy = false;

  async function addItems(items, { open = true, silent = false } = {}) {
    const before = eligibleCount(cart);
    await api(Z.routes.cartAdd + '.js', { items });
    cart = await syncGift(await getCart());
    render();
    bump();
    if (!silent) {
      const after = eligibleCount(cart);
      const crossed = Z.tiers.filter(t => before < t.min && after >= t.min).pop();
      toast(crossed ? '🎁 ' + esc(Z.t.unlocked).replace('{{ offer }}', esc(crossed.label)) : esc(Z.t.added));
    }
    if (open) openDrawer();
  }
  async function changeLine(key, quantity) {
    cart = await api(Z.routes.cartChange + '.js', { id: key, quantity });
    cart = await syncGift(cart);
    render();
  }

  // gift: auto-add the free item above the threshold, remove it below (the discount makes it free)
  // the gift variant counts as the gift even if someone adds it by hand, so it is removed below the threshold
  const isGift = it => !!(it.properties && it.properties._gift) || (Z.giftVariant && it.variant_id === Z.giftVariant);
  const eligibleCount = c => c ? c.items.filter(i => !isGift(i)).reduce((n, i) => n + i.quantity, 0) : 0;
  const totalWithoutGift = c => c.items.filter(i => !isGift(i)).reduce((s, i) => s + i.final_line_price, 0);
  async function syncGift(c) {
    if (!Z.giftVariant) return c;
    const gift = c.items.find(isGift);
    const need = totalWithoutGift(c) >= Z.giftThreshold * rate();
    if (need && !gift) {
      await api(Z.routes.cartAdd + '.js', { items: [{ id: Z.giftVariant, quantity: 1, properties: { _gift: 'true' } }] });
      return getCart();
    }
    if (!need && gift) {
      await api(Z.routes.cartChange + '.js', { id: gift.key, quantity: 0 });
      return getCart();
    }
    if (gift && gift.quantity > 1) {
      await api(Z.routes.cartChange + '.js', { id: gift.key, quantity: 1 });
      return getCart();
    }
    return c;
  }

  // ---------- drawer ----------
  const drawer = () => $('#cart-drawer');
  let lastFocus;
  function openDrawer() {
    const d = drawer(), s = $('.scrim'); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = s.hidden = false;
    requestAnimationFrame(() => { d.classList.add('on'); s.classList.add('on'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('[data-close-cart]', d).focus(), 60);
  }
  function closeDrawer() {
    const d = drawer(), s = $('.scrim'); if (!d) return;
    d.classList.remove('on'); s.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(() => { d.hidden = s.hidden = true; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function bump() { $$('.bag-btn').forEach(b => { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }); }

  function goals(c) {
    const n = eligibleCount(c);
    const total = totalWithoutGift(c);
    const ship = Z.freeShipping * rate(), giftAt = Z.giftThreshold * rate();
    const next = Z.tiers.find(t => n < t.min);
    const top = Z.tiers[Z.tiers.length - 1];
    const tierTxt = next ? tpl(Z.t.addMore, { count: next.min - n, offer: esc(next.label) }) : '🔥 ' + tpl(Z.t.maxUnlocked, { offer: esc(top.label) });
    const tierPct = Math.min(100, n / top.min * 100);
    const pct = (v, m) => Math.max(4, Math.min(100, v / m * 100)).toFixed(1);
    const rows = [`<div class="goal"><span>${tierTxt}</span><div class="bar${next ? '' : ' bar--ok'}"><i style="width:${Math.max(4, tierPct)}%"></i></div></div>`];
    if (Z.freeShipping) rows.push(total >= ship ? `<div class="goal"><span>🚚 ${esc(Z.t.shipFree)}</span></div>` : `<div class="goal"><span>${tpl(Z.t.shipAway, { amount: '<b>' + money(ship - total) + '</b>' })}</span><div class="bar"><i style="width:${pct(total, ship)}%"></i></div></div>`);
    if (Z.giftVariant && Z.giftThreshold) rows.push(total >= giftAt ? `<div class="goal"><span>🎭 ${esc(Z.t.giftFree)}</span></div>` : `<div class="goal"><span>${tpl(Z.t.giftAway, { amount: '<b>' + money(giftAt - total) + '</b>' })}</span><div class="bar"><i style="width:${pct(total, giftAt)}%"></i></div></div>`);
    return `<div class="goals">${rows.join('')}</div>`;
  }

  function render() {
    if (!cart) return;
    const count = cart.item_count;
    $$('.bag-btn__n').forEach(e => e.textContent = count);
    const d = drawer(); if (!d) return;
    const bd = $('.drawer__bd', d), ft = $('.drawer__ft', d);
    const tmpl = $('#cart-empty-tpl');
    if (!cart.items.length) {
      bd.innerHTML = (tmpl ? tmpl.innerHTML : '') + goals(cart);
      ft.innerHTML = '';
      return;
    }
    bd.innerHTML = goals(cart) + cart.items.map(it => {
      const gift = isGift(it);
      const saved = gift ? (Z.giftValue || 0) : it.original_line_price - it.final_line_price;
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      return `<div class="line">
        <a href="${esc(it.url)}" tabindex="-1" aria-hidden="true"><img src="${esc(img)}" alt="" width="72" height="90" loading="lazy"></a>
        <div><a class="line__name" href="${esc(it.url)}">${esc(it.product_title)}</a>
          <div class="line__meta">${esc(it.product_type || '')}${saved > 0 ? ` · <span class="free">−${money(saved)}</span>` : ''}</div>
          ${gift ? '' : `<div class="qty"><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity - 1}" aria-label="−">−</button><span>${it.quantity}</span><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity + 1}" aria-label="+">+</button></div>`}
        </div>
        <div class="line__price">${saved > 0 ? `<s>${money(gift ? saved : it.original_line_price)}</s>` : ''}${it.final_line_price ? money(it.final_line_price) : '🎁'}</div>
      </div>`;
    }).join('') + ($('#cart-ups-tpl') ? $('#cart-ups-tpl').innerHTML : '');
    const disc = cart.original_total_price - cart.total_price;
    const f = $('#cart-footer-tpl');
    ft.innerHTML = f ? f.innerHTML
      .replace('[[subtotal]]', money(cart.original_total_price))
      .replace('[[discount]]', disc > 0 ? money(disc) : '')
      .replace('[[total]]', money(cart.total_price)) : '';
    const dl = $('[data-discount-row]', ft); if (dl) dl.hidden = !(disc > 0);
    // hide add-ons already in the bag
    const inBag = new Set(cart.items.map(i => String(i.variant_id)));
    $$('[data-add]', bd).forEach(b => { if (inBag.has(b.dataset.add)) b.closest('.up').hidden = true; });
  }

  // ---------- events ----------
  document.addEventListener('click', async e => {
    const t = e.target.closest('[data-open-cart], [data-close-cart], [data-add], [data-add-set], [data-q], [data-menu-open], [data-menu-close], [data-tab]');
    if (!t) { if (e.target.classList.contains('scrim')) closeDrawer(); return; }
    if (t.matches('[data-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (t.matches('[data-close-cart]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.matches('[data-menu-open]')) { const m = $('#mnav'); m.hidden = false; requestAnimationFrame(() => m.classList.add('on')); t.setAttribute('aria-expanded', 'true'); return; }
    if (t.matches('[data-menu-close]')) { const m = $('#mnav'); m.classList.remove('on'); setTimeout(() => m.hidden = true, 400); return; }
    if (t.matches('[data-tab]')) { return switchTab(t); }
    if (busy) return;
    busy = true; t.setAttribute('aria-busy', 'true');
    try {
      if (t.matches('[data-add]')) {
        e.preventDefault();
        await addItems([{ id: Number(t.dataset.add), quantity: Number(t.dataset.qty || 1) }], { open: !t.classList.contains('quick') });
        if (t.classList.contains('quick')) { t.classList.add('done'); setTimeout(() => t.classList.remove('done'), 1200); }
      } else if (t.matches('[data-add-set]')) {
        e.preventDefault();
        const ids = t.dataset.addSet.split(',').filter(Boolean).map(Number);
        await addItems(ids.map(id => ({ id, quantity: 1 })), { silent: true });
        toast('🎁 ' + esc(Z.t.setAdded));
      } else if (t.matches('[data-q]')) {
        await changeLine(t.dataset.q, Math.max(0, Number(t.dataset.n)));
      }
    } catch (err) { toast(esc(err.message || Z.t.error)); }
    finally { busy = false; t.removeAttribute('aria-busy'); }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); const m = $('#mnav'); if (m && !m.hidden) $('[data-menu-close]').click(); } });

  // product form: quantity breaks + add (no page reload)
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    btn.setAttribute('aria-busy', 'true');
    try { await addItems([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }]); }
    catch (err) { toast(esc(err.message)); }
    finally { btn.removeAttribute('aria-busy'); }
  });
  document.addEventListener('change', e => {
    const r = e.target.closest('input[name="qb"]');
    if (!r) return;
    const form = r.closest('form');
    form.querySelector('input[name="quantity"]').value = r.value;
    const label = form.querySelector('[data-buy-label]');
    if (label) label.textContent = r.dataset.label;
  });

  // tabs on the home grid
  function switchTab(btn) {
    const box = btn.closest('[data-tabs]');
    $$('[data-tab]', box).forEach(b => b.setAttribute('aria-selected', String(b === btn)));
    $$('[data-panel]', box).forEach(p => { p.hidden = p.dataset.panel !== btn.dataset.tab; });
  }

  // product gallery
  document.addEventListener('click', e => {
    const b = e.target.closest('.thumbs button');
    if (!b) return;
    const g = b.closest('.gallery'), img = $('.stage img', g), label = $('.stage__label', g);
    $$('.thumbs button', g).forEach(x => x.setAttribute('aria-current', String(x === b)));
    img.src = b.dataset.src; img.srcset = b.dataset.srcset || ''; img.alt = b.dataset.alt || '';
    if (label) { label.textContent = b.dataset.label || ''; label.hidden = !b.dataset.label; }
  });

  // sticky add-to-cart on phones
  const buyBtn = $('[data-main-buy]'), sticky = $('.sticky-buy');
  if (buyBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('on', on); sticky.inert = !on;
    }).observe(buyBtn);
  }

  // delivery estimate (business days)
  $$('[data-eta]').forEach(el => {
    const [a, b] = el.dataset.eta.split('-').map(Number);
    const add = n => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const f = d => d.toLocaleDateString(Z.locale, { day: 'numeric', month: 'short' });
    el.textContent = `${f(add(a))} – ${f(add(b))}`;
  });

  // reveal on scroll
  const rv = $$('.rv');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
    rv.forEach(el => io.observe(el));
  } else rv.forEach(el => el.classList.add('in'));

  // localization selects submit on change
  $$('.localization select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  // first load
  getCart().then(c => syncGift(c)).then(c => { cart = c; render(); if (new URLSearchParams(location.search).has('cart')) openDrawer(); }).catch(() => {});
})();
